<template>
  <div class="wrapper">
    <loading v-if="showLoading"></loading>
    <section class="head">
      <img
        class="head__img"
        src="@/assets/img/splashscreen/ad_hd_w750_h600.png"
      />
    </section>

    <section class="registration">
      <section class="registration__title">入驻申请</section>
      <section class="registration__instruction">
        您可查看下方详细介绍如何为您的门店带来更多流量，若有入驻意向请点击下方【我要加入】，点击后1-2个工作日会有黑卡代运营与您主动联系，请耐心等待。
      </section>

      <button
        class="registration__btn"
        :class="!registered ? 'registration__btn--active' : ''"
        :disabled="registered"
        @click="submit()"
      >
        {{ registered ? '正在安排代运营与您联系' : '我要加入' }}
      </button>
    </section>

    <section class="advantage">
      <img
        class="advantage__img"
        src="@/assets/img/splashscreen/ad_advantage_w750_h2345.png"
      />
    </section>
  </div>
</template>
<script lang="ts">
import Loading from '@/components/Loading.vue';
import lazyInject from '@/di';
import AdRegistrationService from '@/services/ad.registration.service';
import StorageService from '@/services/storage.service';
import { Toast } from 'mint-ui';
import { Vue, Component } from 'vue-property-decorator';

@Component({
  components: {
    loading: Loading,
  },
})
export default class AdRegistration extends Vue {
  @lazyInject(StorageService)
  protected storage!: StorageService;

  @lazyInject(AdRegistrationService)
  protected adRegistrationService!: AdRegistrationService;

  public registered = false;

  public showLoading = true;

  public async submit() {
    try {
      const res = await this.adRegistrationService.signup();
      if (res) {
        this.registered = true;
      }
    } catch (error) {
      Toast({
        message: `${error}`,
        iconClass: 'icon icon-error',
      });
    } finally {
      this.showLoading = false;
    }
  }

  public async created() {
    // eslint-disable-next-line no-console
    console.log('route---', this.$route);
    const token = this.$route.query.tk;
    const data = {  
      token,
    };
    this.storage.set('user', data);
    this.showLoading = false;
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  background: #f0f1f2;
  min-height: 100vh;
  padding-bottom: 10px;
  margin: 0 auto;
  max-width: 750px;
}
.head {
  box-sizing: border-box;
  width: 100%;
  &__img {
    width: 100%;
  }
}
.registration {
  background: url('~@/assets/img/splashscreen/ad_signup_bg_w1077_h128.png')
    no-repeat 0 0 #fff;
  background-size: 100% 43px;
  border-radius: 12px;
  box-sizing: border-box;
  font-size: 14px;
  margin: -80px 8px 0 8px;
  padding: 0 12px 20px 12px;
  position: relative;
  z-index: 0;

  &__title {
    align-items: center;
    color: #000;
    display: flex;
    font-size: 16px;
    font-weight: bold;
    height: 44px;
    padding-top: 10px;
  }
  &__instruction {
    color: #454545;
    line-height: 22px;
    padding: 10px 0 25px 0;
  }

  &__btn {
    background: #fff;
    border-radius: 50px;
    box-sizing: border-box;
    border: none;
    color: #000;
    font-size: 16px;
    height: 40px;
    padding: 0;
    position: relative;
    width: 100%;
  }
  &__btn::after {
    border: 1px solid #ababab;
    border-radius: 50px;
    content: '';
    height: 200%;
    left: 0;
    position: absolute;
    top: 0;
    transform-origin: 0 0;
    transform: scale(0.5);
    width: 200%;
  }
  &__btn.registration__btn--active {
    background: linear-gradient(#ff5e33, #ff7733);
    color: #fff;
  }
  .registration__btn--active::after {
    display: none;
  }
}
.advantage {
  box-sizing: border-box;
  margin-top: 10px;
  padding: 0 8px;
  width: 100%;
  &__img {
    border-radius: 12px;
    height: 100%;
    width: 100%;
  }
}
</style>
